<template>

<com-item name="players.mostgames" :has-more="data.total > 5" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Most games">

	<template v-slot:about>

		<p>Players with the most different games played.</p>

	</template>

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data.players" :subtext="item.plays + ' play' + ((item.plays > 1) ? 's' : '')" count-text="game" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/mostgames']

		},

		active: function() {

			return this.data.players.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersMostgames'
			})
		
		}

	}

}

</script>

<style scoped>

</style>